import { Link } from '@inertiajs/react'

interface Account { id: number; name: string; slug: string; logo_url?: string | null }
interface Customer { id: number; name: string; email: string }
interface PointAccount { id: number; account_name: string; account_slug: string; balance: number; lifetime_earned: number; lifetime_redeemed: number }
interface Props { account: Account; customer: Customer; point_accounts: PointAccount[]; total_balance: number }

export default function PortalMyPoints({ account, customer, point_accounts, total_balance }: Props) {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#202020] text-white">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link href={`/${account.slug}/catalog`} className="flex items-center gap-2 font-bold text-lg">
            {account.logo_url && <img src={account.logo_url} className="h-8 w-8 object-contain bg-white rounded" />}
            {account.name}
          </Link>
          <div className="flex gap-3 text-sm">
            <Link href={`/${account.slug}/portal/orders`} className="hover:text-[#FFC107]">Mis pedidos</Link>
            <Link href={`/${account.slug}/portal/logout`} method="delete" as="button" className="hover:text-[#FFC107]">Cerrar sesión</Link>
          </div>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold text-[#202020] mb-1">Mis Puntos</h1>
        <p className="text-gray-500 mb-6">Hola, {customer.name}</p>

        <div className="bg-gradient-to-r from-[#55ACEE] to-[#FFC107] text-white rounded-lg shadow-lg p-6 mb-6">
          <p className="text-sm opacity-90">Balance total</p>
          <p className="text-5xl font-bold">{total_balance}</p>
          <p className="text-sm opacity-90 mt-1">puntos</p>
        </div>

        {point_accounts.length === 0 ? (
          <div className="bg-white rounded-lg shadow p-12 text-center">
            <p className="text-gray-500 mb-3">Aún no tienes puntos</p>
            <p className="text-sm text-gray-400 mb-4">Ganas 3% del subtotal (antes de impuestos) en cada compra</p>
            <Link href={`/${account.slug}/catalog`} className="text-[#55ACEE] hover:underline">Empezar a comprar</Link>
          </div>
        ) : (
          <div className="space-y-3">
            <h2 className="font-semibold text-[#202020]">Por tienda</h2>
            {point_accounts.map((pa) => (
              <div key={pa.id} className="bg-white rounded-lg shadow p-4">
                <div className="flex items-center justify-between mb-2">
                  <p className="font-semibold text-[#202020]">{pa.account_name}</p>
                  <p className="text-2xl font-bold text-[#55ACEE]">{pa.balance}</p>
                </div>
                <div className="text-xs text-gray-500 flex gap-4">
                  <span>Ganados: {pa.lifetime_earned}</span>
                  <span>Canjeados: {pa.lifetime_redeemed}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
